/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowFigureASquareLeftIcon24Solid = forwardRef('ArrowFigureASquareLeftIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M17.5 2A4.5 4.5 0 0 1 22 6.5v11a4.5 4.5 0 0 1-4.5 4.5h-11A4.5 4.5 0 0 1 2 17.5v-11A4.5 4.5 0 0 1 6.5 2h11Zm-6.246 5.293a1 1 0 0 1 0 1.414L8.961 11H17a1 1 0 1 1 0 2H8.961l2.293 2.293a1 1 0 1 1-1.414 1.414l-3.006-3.006a2.406 2.406 0 0 1 0-3.402L9.84 7.293a1 1 0 0 1 1.414 0Z" })));
});
